import { Stack } from "@mui/material";
import clsx from "clsx";
import React, { type FC } from "react";
import "./NoExpandIcon.scss";

interface ExpandNoExpandedIconProps {
  isLastRow?: boolean;
  nestedChilde?: boolean;
}

export const NoExpandIcon: FC<ExpandNoExpandedIconProps> = ({
  isLastRow,
  nestedChilde = false,
}) => {
  return (
    <Stack
      direction="row"
      className={clsx("no-expand-container", { nested: nestedChilde })}
    >
      {!isLastRow ? (
        <>
          <div className="vertical" />
          {!nestedChilde && <div className="horizontal" />}
        </>
      ) : (
        <div className="last" />
      )}
    </Stack>
  );
};
